import React from 'react';
import Head from 'next/head';
import { Layout } from 'antd';
const { Header, Footer, Sider, Content, Row, Col } = Layout;

class Login extends React.Component {
  render() {
    return (<Layout>
      <Head>
        <title>{this.props.title || "DOHU"}</title>
      </Head>
      <div id="login">
        <Content>
          {this.props.children}
        </Content>
      </div>
    </Layout>
    );
  }
}


export default Login;